import React, { forwardRef } from 'react';

const IcStatusDeny = forwardRef(
  (properties, ref) => /* @__PURE__ */ React.createElement(
    "svg",
    {
      fill: "none",
      height: "16",
      ref,
      viewBox: "0 0 16 16",
      width: "16",
      xmlns: "http://www.w3.org/2000/svg",
      ...properties
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8Zm2 0a4 4 0 0 0 6.03 3.45L4.55 5.97C4.2 6.57 4 7.26 4 8Zm7.45 2.03L5.97 4.55a4 4 0 0 1 5.48 5.48Z",
        fill: "var(--negative-icon-default)",
        fillRule: "evenodd"
      }
    )
  )
);

export { IcStatusDeny };
//# sourceMappingURL=ic-status-deny.js.map
